import React from 'react';
import { Box, Separator, Colors } from '@utex/ui-kit';
import { useQuery, gql } from '@apollo/client';
import { UserAvatar } from './components/UserAvatar';
import { Container, Name, Email } from './styles';
import { getUserInitials } from './getUserInitials';
import { Placeholder } from './components/Placeholder';

interface UserInfoProps {
  profileLink: string;
  onClick: () => void;
  isBottomBorderVisible?: boolean;
}

const query = gql`
  query {
    currentUser {
      userInfo {
        email
        login
        avatarUrl
        firstName
        lastName
      }
    }
  }
`;

interface QueryInterface {
  currentUser: {
    userInfo: {
      email: string;
      login: string;
      avatarUrl?: string;
      firstName?: string;
      lastName?: string;
    };
  };
}

export function UserInfo({ profileLink, isBottomBorderVisible, onClick }: UserInfoProps) {
  const { loading, error, data } = useQuery<QueryInterface>(query);

  if (loading || error || !data?.currentUser) {
    return <Placeholder isBottomBorderVisible={isBottomBorderVisible} />;
  }

  const { userInfo } = data.currentUser;

  return (
    <>
      <Container href={profileLink} target="_blank">
        <UserAvatar onClick={onClick} email={userInfo.email} text={getUserInitials(userInfo)} />
        {!userInfo.firstName && !userInfo.lastName ? (
          <Name data-testid="username">{userInfo.email}</Name>
        ) : (
          <>
            <Name data-testid="username">{userInfo.firstName + ' ' + userInfo.lastName}</Name>
            <Email data-testid="userEmail">{userInfo.email}</Email>
          </>
        )}
      </Container>

      {isBottomBorderVisible && (
        <Box display={{ phonablet: 'none' }} marginBottom={10}>
          <Separator margin={[0, 24]} color={Colors.ut.border5} />
        </Box>
      )}
    </>
  );
}
